<!-- 由 suu 创建于 2021-07-07 星期三 -->
<template>
  <div class="nutrition-info" v-if="info">
    <!-- 标题栏 -->
    <div class="hi-title">
      <div class="t-left">营养元素</div>
      <div class="t-right">单位：每{{ info.weight }}克</div>
    </div>
    <div class="ci-regien">
      <div class="ci-item" v-for="(item, index) in nutrition" :key="index">
        <van-circle
          class="i-ci"
          v-model="currentRate[item.title]"
          :rate="item.rate"
          :stroke-width="80"
          stroke-linecap="butt"
          :text="ciText(item)"
          :color="item.color"
          speed="40"
          layer-color="#f1f1f1"
        />
        <div class="i-title">
          {{ item.title }} <br />
          {{ item.gram }}克
        </div>
      </div>
    </div>
    <div class="ci-tips">
      注：以上为三大营养素的供能比例，不是重量比例。其中，脂肪的供能效率比较高，是碳水化合物和蛋白质的2.25倍。
    </div>
    <div
      class="ci-btn user-btn"
      @click="
        $router.push(
          '/calorie-query/food-details?foodid=' + $route.query.foodid
        )
      "
    >
      更多营养素
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Circle } from 'vant'

Vue.use(Circle)
export default {
  name: 'nutrition-info',

  components: {},

  props: {
    info: {}
  },

  data() {
    return {
      currentRate: {},
      rate: 80
    }
  },

  computed: {
    nutrition() {
      return {
        1: {
          title: '蛋白质',
          rate: this.info.protein_e.replace('%', ''),
          color: '#838AAE',
          gram: this.info.protein
        },
        2: {
          title: '脂肪',
          rate: this.info.fat_e.replace('%', ''),
          color: '#ffabab',
          gram: this.info.fat
        },
        3: {
          title: '碳水化合物',
          rate: this.info.carbohydrate_e.replace('%', ''),
          color: '#9ddde2',
          gram: this.info.carbohydrate
        }
      }
    }
    // text() {
    //   return this.currentRate.toFixed(1) + '%'
    // }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 获取环型进度中间文案
    ciText(item) {
      return parseInt(this.currentRate[item.title]).toFixed(1) + '%'
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.nutrition-info {
  width: 91.5vw;
  box-sizing: border-box;
  padding: 3.7vw 4.3vw;
  background-color: #ffffff;
  border-radius: 2.7vw;
  margin-top: 4.3vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  .hi-title {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .t-left {
      font-size: 4vw;
      font-weight: 600;
      color: #000;
    }
    .t-right {
      font-size: 2.7vw;
    }
  }
  .ci-regien {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 9.6vw;
    .ci-item {
      width: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.7);
      .i-ci {
        width: 20.3vw !important;
        height: 20.3vw !important;
      }
      .i-title {
        margin-top: 5.1vw;
      }
    }
  }

  .ci-tips {
    width: 100%;
    box-sizing: border-box;
    margin-top: 8vw;
    font-size: 3.2vw;
    line-height: 5.9vw;
    color: rgba(0, 0, 0, 0.5);
  }
  .ci-btn {
    width: 72.8vw;
    height: 9.6vw;
    background-color: #ffffff;
    border-radius: 2.7vw;
    border: solid 0.3vw #f1f1f1;
    margin-top: 6.4vw;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3.7vw;
    font-weight: 600;
    letter-spacing: 0.8vw;
    color: #000000;
  }
}
</style>
